<template>
  <div class="main">
    <b-row class="mb-5">
      <b-col md="2">
        <b-input-group>
          <date-picker
            placeholder="Từ"
            class="form-control form-control-sm"
            :config="dpConfigs.date"
            v-model="apiParams.fromDate"
          ></date-picker>
        </b-input-group>
      </b-col>
      <b-col md="2">
        <b-input-group>
          <date-picker
            placeholder="Đến"
            class="form-control form-control-sm"
            :config="dpConfigs.date"
            v-model="apiParams.toDate"
          ></date-picker>
        </b-input-group>
      </b-col>
      <b-col md="2">
        <b-form>
          <b-form-select
            v-model="apiParams.type"
            :options="BILL_TYPE_OPTIONS"
            class="select-style"
            size="sm"
          ></b-form-select>
        </b-form>
      </b-col>
      <b-col md="1">
        <b-button
          style="width: 70px"
          variant="primary"
          size="sm"
          @click="onFilter"
        >Lọc
        </b-button>
      </b-col>
    </b-row>
    <b-table-simple class="table-bordered table-hover tbody-hover col-md-12">
      <b-thead>
        <b-tr>
          <b-th class="text-center td-date">Ngày</b-th>
          <b-th class="text-center td-code">ID</b-th>
          <b-th class="text-center td-store">Cửa hàng</b-th>
          <b-th class="text-center td-customer">Khách hàng</b-th>
          <b-th class="text-center td-product-name">Sản phẩm</b-th>
          <b-th class="text-center td-product-price">Giá</b-th>
          <b-th class="text-center td-quantity">SL</b-th>
          <b-th class="text-center td-discount-item">C.Khấu</b-th>
          <b-th class="text-center td-total-amount">Tổng tiền</b-th>
          <b-th class="text-center td-total-payment">Thanh toán</b-th>
          <b-th class="text-center td-note">Ghi chú</b-th>
          <b-th class="text-center "></b-th>
        </b-tr>
      </b-thead>
      <b-tbody
        v-for="bill in mainList.dataset"
        :key="bill.id"
      >
        <b-tr
          v-for="(item, index) in bill.billItems"
          :key="index"
        >
          <b-td
            :rowspan="bill.billItems.length"
            class="td-date"
            v-show="isShowRow(bill.billItems, item)"
          >
            {{ formatDate(bill.createdAt) }}
            <p v-if="bill.cashierName">
              <b class="mb-0 ">
                NVTN:
                <br />
              </b>
              <span>{{ bill.cashierName }}</span>
            </p>
            <p v-if="bill.saleName">
              <b class="mb-0 ">
                NVBH:
                <br />
              </b>
              <span>{{ bill.saleName }}</span>
            </p>
          </b-td>
          <b-td
            :rowspan="bill.billItems.length"
            class="text-center td-code"
            v-show="isShowRow(bill.billItems, item)"
          >
            <div>
              <router-link
                :to="{
                  path: '/bills/update-bill',
                  query: { id: bill.billNumber }
                }"
                target="_blank"
              >{{ bill.billNumber }}
              </router-link>
            </div>
            <div class="text-center">
              <i
                v-if="bill.type === 'SHIPPING'"
                class="fas fa-shipping-fast text-success"
                v-b-tooltip.hover
                title="Hóa đơn giao hàng từ đơn hàng"
              ></i>
              <i
                v-if="bill.type === 'RETAIL' && bill.orderId"
                class="fas fa-shopping-basket text-success"
                v-b-tooltip.hover
                title="Hóa đơn từ đơn hàng"
              ></i>
              <i
                v-if="bill.type === 'RETAIL' && !bill.orderId"
                class="fas fa-shopping-bag text-info"
                v-b-tooltip.hover
                title="Hóa đơn bán lẻ"
              ></i>
              <i
                v-if="bill.type === 'WHOLESALE'"
                class="fas fa-shopping-cart text-warning"
                v-b-tooltip.hover
                title="Hóa đơn bán buôn"
              ></i>
              <i
                v-if="bill.type === 3"
                class="fas fa-undo-alt text-dark"
                v-b-tooltip.hover
                title="Hóa đơn trả hàng"
              ></i>
              <div
                v-if="bill.orderId"
                class="orderCode"
                @click="redirectToOrder(bill.orderId)"
              >
                <span style="color: darkgoldenrod">{{ bill.orderId }}</span>
              </div>
            </div>
          </b-td>
          <b-td
            :rowspan="bill.billItems.length"
            class="text-left td-store"
            v-show="isShowRow(bill.billItems, item)"
          >
            {{ bill.store?.name }}
            <br />
            <span
              v-if="bill.companyName"
              style="font-size: 10px"
            >( {{ bill.companyName }} )</span>
          </b-td>
          <b-td
            :rowspan="bill.billItems.length"
            class="text-left tdCenter td-customer"
            v-show="isShowRow(bill.billItems, item)"
          >
            <b>{{ bill.customerName }}</b>
            <p>{{ bill.customerPhone }}</p>
          </b-td>
          <b-td class="text-left td-product-name">
            <template v-if="item.type === BILL_ITEM_TYPE.PRODUCT">
              <div>
                {{ item.product.name }}
              </div>
              <div v-if="item.productChassis">
                <p class="text-imei-no">
                  SK: {{ item.productChassis.chassisNumber }}
                  <br />
                  SM: {{ item.productChassis.engineNumber }}
                </p>
              </div>
              <div v-if="item.productSeries">
                <p class="text-imei-no">
                  SERI: {{ item.productSeries.serialNumber }}
                </p>
              </div>
            </template>

            <template
              v-else-if="item.type === BILL_ITEM_TYPE.PRODUCT_BONUS"
              class="font-size-gift"
            >
              <i
                style="color: #2e7d32"
                class="fas fa-gift ml-4 mr-1"
                title="Quà tặng"
              ></i>
              {{ item.product.name }}
            </template>
          </b-td>
          <b-td class="text-right td-product-price">
            {{ convertPrice(item.productPrice) }}
          </b-td>
          <b-td class="text-right tdCenter td-quantity">
            {{ item.quantity }}
          </b-td>
          <b-td class="text-right td-discount-item">
            <span v-if="item.discountType === 'AMOUNT'">
              {{ convertPrice(item.discountAmount) }}đ
            </span>
            <br />
            <span
              v-if="item.discountType === 'PERCENT' && item.discountAmount > 0"
            >
              {{ convertPrice(item.discountAmount) }}%
            </span>
            <br />
            <span
              v-if="
                item.discountType === 'PERCENT' && item.discountAmount === 0
              "
            >
              {{ convertPrice(item.discountAmount) }}
            </span>
          </b-td>
          <b-td
            :rowspan="bill.billItems.length"
            class="text-right tdCenter"
            v-show="isShowRow(bill.billItems, item)"
            style="width: 10%; color: #3c763d; font-weight: 700"
          >
            <p v-show="bill.shipFee > 0" class="border-0">
              <i
                v-b-tooltip.hover
                title="Phí ship"
                class="fas fa-shipping-fast icon-color"
              ></i>
              : {{ convertPrice(bill.shipFee) }}
            </p>
            <p v-show="bill.discountAmount > 0" class="border-0 text-warning">
              <i
                v-b-tooltip.hover
                title="Chiết khấu tổng"
                class="fa fa-arrow-down icon-color"
              ></i>
              :
              {{
                bill.discountType === 'PERCENT'
                  ? bill.discountAmount + '%'
                  : convertPrice(bill.discountAmount) + 'đ'
              }}
            </p>
            <span>{{ convertPrice(bill.totalAmount) }}</span>
          </b-td>
          <b-td
            :rowspan="bill.billItems.length"
            class="text-right tdCenter"
            v-show="isShowRow(bill.billItems, item)"
            style="width: 10%"
          >
            <template v-if="bill.payments && bill.payments.length">
              <div
                v-for="(payment, pIndex) in bill.payments"
                :key="pIndex"
                class="mb-2"
              >
                <span class="mr-2">
                  <i
                    v-b-tooltip.hover
                    :title="
                      payment.accountName || PAYMENT_TYPE_NAME[payment.type]
                    "
                    class="icon-color text-dark mr-1"
                    :class="
                      payment.type === PAYMENT_TYPE.CASH
                        ? 'fas fa-money-bill-alt'
                        : payment.type === PAYMENT_TYPE.TRANSFER
                        ? 'fa fa-university'
                        : payment.type === PAYMENT_TYPE.CREDIT
                        ? 'fa fa-credit-card'
                        : payment.type === PAYMENT_TYPE.INSTALLMENT
                        ? 'fa fa-cube'
                        : ''
                    "
                  ></i>
                  :
                </span>
                <span style="font-weight: 700">
                  {{ convertPrice(payment.amount) }}
                </span>
              </div>
            </template>

            <b v-if="bill.extraAmount > 0" class="d-block text-primary mb-2">
              Tiền thừa:
              <span class="d-block">{{ convertPrice(bill.extraAmount) }}</span>
            </b>
            <b
              v-if="bill.extraAmount < 0"
              class="d-block mb-2"
              style="color: #e65b5b"
            >
              Còn thiếu:
              <span class="d-block">
                {{ convertPrice(bill.extraAmount * -1) }}
              </span>
            </b>
            <p v-show="bill.leftAmount > 0">
              <b>
                Công nợ:
                <span
                  class="d-block"
                  v-text="convertPrice(bill.leftAmount)"
                ></span>
              </b>
            </p>
          </b-td>

          <b-td
            :rowspan="bill.billItems.length"
            class="text-left tdCenter"
            v-show="isShowRow(bill.billItems, item)"
            style="width: 10%"
          >
            {{ bill.customerNote }}
          </b-td>
          <b-td
            :rowspan="bill.billItems.length"
            class="text-center"
            v-show="isShowRow(bill.billItems, item)"
            style="width: 5%"
          >
            <b-dropdown size="sm" no-caret right lazy>
              <template slot="button-content">
                <i style="font-size: 1rem" class="flaticon2-settings pr-0"></i>
              </template>
              <b-dropdown-item @click="printBill(bill)">
                <span style="color: #3f4254; font-size: 12px">
                  <i style="font-size: 1rem" class="flaticon2-printer"></i>
                  &nbsp; In hóa đơn
                </span>
              </b-dropdown-item>
              <!-- <b-dropdown-item @click="returnBill(bill)">
                <span style="color: #3f4254; font-size: 12px">
                  <i style="font-size: 1rem" class="flaticon2-reply-1"></i>
                  &nbsp; Trả hàng
                </span>
              </b-dropdown-item> -->
              <b-dropdown-item @click="editItem(bill)">
                <span style="color: #3f4254; font-size: 12px">
                  <i style="font-size: 1rem" class="flaticon-eye"></i>
                  &nbsp; Chi tiết hóa đơn
                </span>
              </b-dropdown-item>
            </b-dropdown>
          </b-td>
        </b-tr>
      </b-tbody>
      <b-tfoot>
        <tr>
          <td colspan="6" class="text-right">
            <b>Tổng</b>
          </td>
          <td class="text-right">
            <b>{{ sumQty }}</b>
          </td>
          <td class="text-right">
            <b>{{ convertPrice(sumAmount('discountAmount')) }}</b>
          </td>
          <td class="text-right">
            <b>{{ convertPrice(sumAmount('totalAmount')) }}</b>
          </td>
          <td class="text-right">
            <b>{{ convertPrice(sumAmount('totalAmount')) }}</b>
          </td>
          <td></td>
          <td></td>
        </tr>
      </b-tfoot>
    </b-table-simple>
    <vcl-table
      v-if="onLoadingList"
      :speed="5"
      :animate="true"
      :columns="11"
    />
    <b-row>
      <b-col
        lg="3"
        md="3"
        sm="12"
      >
        <p
          class="mt-3 text-dark"
          style="font-weight: 500"
        >
          Tổng số:
          {{ mainList.total }}
        </p>
      </b-col>
      <b-col
        lg="9"
        md="9"
        sm="12"
      >
        <BPaginationNavCustom
          :number-of-pages="mainList.pages"
          :current-page="currentPage"
          :total-page="mainList.total"
          :linkParams="linkParams"
          @page-change="fetchMainData"
        >
        </BPaginationNavCustom>
      </b-col>
    </b-row>
  </div>
</template>

<style lang="scss" scoped>
.main ::v-deep {
  width: 100%;
  .break-line {
    white-space: break-spaces;
  }
  .icon:hover {
    background-color: #90c6fc;
  }
  .text-imei-no {
    font-size: 12px;
    font-style: italic;
    color: dodgerblue;
  }
  .td-date {
    width: 5%;
    font-size: 11px;
  }
  .td-code {
    width: 5%;
  }
  .td-store {
    width: 5%;
  }
  .td-customer {
    width: 7%;
  }
  .td-product-name {
    width: 15%;
  }
  .td-product-price {
    width: 8%;
  }
  .td-quantity {
    width: 3%;
  }
  .td-discount-item {
    width: 5%;
  }
  .td-total-amount {
    width: 8%;
  }
  .td-total-payment {
    width: 10%;
    font-weight: 700;
  }
  .td-note {
    width: 19%;
  }
  .tdAction {
    width: 5%;
  }
  .wrapword {
    white-space: -moz-pre-wrap !important; /* Mozilla, since 1999 */
    white-space: -webkit-pre-wrap; /* Chrome & Safari */
    white-space: -pre-wrap; /* Opera 4-6 */
    white-space: -o-pre-wrap; /* Opera 7 */
    white-space: pre-wrap; /* CSS3 */
    word-wrap: break-word; /* Internet Explorer 5.5+ */
    word-break: break-all;
    white-space: normal;
  }
  .table tbody + tbody {
    border-top: unset !important;
  }
  .table th,
  .table td {
    vertical-align: middle;
  }
  .tdCenter {
    vertical-align: left !important;
  }
  .tdTextAlign {
    vertical-align: middle;
  }
  .tdTextAlignPrice {
    text-align: right !important;
    vertical-align: middle;
  }
  .select-style {
    border-radius: 0.28rem;
    box-shadow: none;
    border: 1px solid #ced4da;
  }
  .font-size-gift {
    font-size: 11px;
  }
  .font-size-attach {
    font-size: 11px;
  }
  .orderCode:hover {
    text-decoration: underline;
    cursor: pointer;
  }
}
</style>

<script>
import { VclTable } from 'vue-content-loading';
import ApiService from '@/core/services/api.service';
import { cmdUrl } from '@/utils/apiUrl';
import _ from 'lodash';
import datePicker from 'vue-bootstrap-datetimepicker';
import moment from 'moment';
import { formatDate, convertPrice, makeToastFaile } from '@/utils/common';
import BPaginationNavCustom from '@/view/base/bootstrap/BPaginationNavCustom.vue';
import { BILL_ITEM_TYPE, PAYMENT_TYPE } from '@/utils/enum';
import { BILL_TYPE_OPTIONS, PAYMENT_TYPE_NAME } from '@/utils/constants';
export default {
  props: ['customerId'],
  components: {
    VclTable,
    datePicker,
    BPaginationNavCustom,
  },
  data() {
    return {
      BILL_ITEM_TYPE,
      PAYMENT_TYPE,
      PAYMENT_TYPE_NAME,
      BILL_TYPE_OPTIONS,
      linkParams: {},
      customerKey: null,
      mainList: {
        dataset: [],
        total: 0,
        pages: 1,
      },
      apiParams: {
        page: 1,
        pageSize: 10,
        fromDate: null,
        toDate: null,
        type: null,
      },
      onLoadingList: false,
      dpConfigs: {
        date: {
          format: 'DD/MM/YYYY',
          useCurrent: false,
          showClear: true,
          showClose: true,
          minDate: false,
          maxDate: false,
          locale: 'vi',
          sideBySide: true,
        },
      },
      currentPage: 1,
    };
  },
  mounted() {
    this.getParamFilters();
    this.fetchMainData();
  },
  methods: {
    formatDate,
    convertPrice,
    makeToastFaile,

    onFilter() {
      this.apiParams.page = 1;
      this.currentPage = 1;
      this.fetchMainData();
    },

    fetchMainData: function (pageInfo) {
      if (pageInfo && pageInfo.page) {
        this.apiParams.page = pageInfo.page;
        this.currentPage = pageInfo.page;
      }

      if (!this.customerKey) {
        this.makeToastFaile('Không tìm thấy ID khách hàng');
        return;
      }

      this.onLoadingList = true;

      const params = {
        ...this.apiParams,
        fromDate: this.apiParams.fromDate
          ? moment(this.apiParams.fromDate, 'DD/MM/YYYY').format('YYYY-MM-DD')
          : null,
        toDate: this.apiParams.toDate
          ? moment(this.apiParams.toDate, 'DD/MM/YYYY').format(
              'YYYY-MM-DD 23:59',
            )
          : null,
      };

      ApiService.query(
        cmdUrl.BillUrl.byCustomer.replace('{id}', this.customerKey),
        { params },
      )
        .then((response) => {
          const respData = response.data.data;
          this.mainList = {
            dataset: respData.data || [],
            total: respData.paginations?.total || 0,
            pages: respData.paginations?.totalPages || 1,
          };

          this.onLoadingList = false;
        })
        .catch(() => {
          this.onLoadingList = false;
          this.makeToastFaile('Lỗi khi tải danh sách hóa đơn');
        });
    },

    getParamFilters() {
      this.currentPage = parseInt(this.$route.query.page) || 1;
      this.customerKey =
        this.customerId || this.$route.query.id || this.$route.query.phoneNo;
      this.apiParams.page = this.currentPage;

      if (this.$route.query.fromDate) {
        this.apiParams.fromDate = this.$route.query.fromDate;
      }
      if (this.$route.query.toDate) {
        this.apiParams.toDate = this.$route.query.toDate;
      }
      if (this.$route.query.type) {
        this.apiParams.type = this.$route.query.type;
      }

      this.linkParams = {
        id: this.customerKey,
      };
    },
    isShowRow: function (listData, item) {
      return _.findIndex(listData, ['id', item.id]) === 0;
    },
    sumAmount(key) {
      const outItems = this.mainList.dataset;
      return _.reduce(
        outItems,
        (sum, item) => {
          return sum + parseFloat(item[key] || 0);
        },
        0,
      );
    },
    redirectToOrder: function (orderId) {
      const { href } = this.$router.resolve({
        name: 'edit-order',
        params: { id: orderId },
      });
      window.open(href, '_blank');
    },
    returnBill: function (item) {
      this.$router.push({
        name: 'add-return-bill',
        query: { id: item.billNumber },
      });
    },
    editItem: function (item) {
      const { href } = this.$router.resolve({
        name: 'update-bill',
        query: { id: item.billNumber },
      });
      window.open(href, '_blank');
    },
    printBill: async function (item) {
      let routeData = this.$router.resolve({
        name: 'print-bill',
        query: { id: item.billNumber },
      });
      window.open(routeData.href, '_blank');
    },
  },
  computed: {
    sumQty: function () {
      let sum = 0;
      _.map(this.mainList.dataset, (item) => {
        const tmpSum = _.sumBy(item.billItems, 'quantity');
        sum += tmpSum;
      });
      return sum;
    },
  },
  watch: {
    customerId: {
      immediate: true,
      handler(newVal) {
        if (newVal && newVal !== this.customerKey) {
          this.customerKey = newVal;
          this.fetchMainData();
        }
      },
    },
  },
};
</script>
